if (!window.dynamicsNutritionDrawerBound) {
  window.dynamicsNutritionDrawerBound = true;

  function readNutrition(root) {
    const sections = { nutrition: { rows: [], choices: [] }, amino: { rows: [], choices: [] } };
    const notes = [];
    let current = 'nutrition';
    let inNotes = false;
    const lines = (root.dataset.dnNutrition || '').split(/\r?\n/).map(line => line.trim()).filter(Boolean);

    lines.forEach(line => {
      if (line === 'Nährwertangaben' || line === 'Nährwerte') return;
      if (line === 'Aminosäuren') { current = 'amino'; inNotes = false; return; }
      if (line === 'Mineralstoffe') { current = 'nutrition'; sections.nutrition.rows.push({ heading: 'Mineralstoffe' }); return; }
      if (line.indexOf(' | ') === -1) { inNotes = true; notes.push(line); return; }
      if (inNotes) { notes.push(line); return; }

      const parts = line.split(' | ').map(part => part.trim());
      const first = parts[0].toLowerCase();
      const isHeader = ['nährwerte', 'nährwertangaben', 'inhalt', 'aminosäure', 'mineralstoff'].includes(first) && parts.slice(1).some(part => /^pro\s/i.test(part));
      if (isHeader) {
        const choices = [];
        parts.forEach((part, index) => {
          if (index === 0 || !/^pro\s/i.test(part)) return;
          const next = parts[index + 1] || '';
          choices.push({ label: part, index, nrvIndex: /referenzmenge/i.test(next) ? index + 1 : null });
        });
        sections[current].choices = choices;
        return;
      }

      const rows = sections[current].rows;
      const last = rows[rows.length - 1];
      if (first === 'energie' && last && last.label && last.label.toLowerCase() === 'energie') {
        for (let index = 1; index < parts.length; index += 1) {
          last.values[index] = [last.values[index], parts[index]].filter(Boolean).join(' / ');
        }
        return;
      }
      rows.push({ label: parts[0], values: parts, group: /^(essentielle|nichtessentielle) aminosäuren$/i.test(parts[0]) });
    });
    return { sections, notes };
  }

  function fillChoices(root, name, section) {
    const select = root.querySelector(`[data-dn-basis="${name}"]`);
    select.replaceChildren(...section.choices.map(choice => {
      const option = document.createElement('option');
      option.value = String(choice.index);
      option.textContent = choice.label;
      return option;
    }));
    select.hidden = section.choices.length <= 1;
  }

  function fillRows(root, name, section) {
    const container = root.querySelector(`[data-dn-rows="${name}"]`);
    const select = root.querySelector(`[data-dn-basis="${name}"]`);
    const choice = section.choices.find(item => item.index === Number(select.value)) || section.choices[0];
    const hasNrv = Boolean(choice && choice.nrvIndex && section.rows.some(item => item.values && item.values[choice.nrvIndex] && item.values[choice.nrvIndex] !== '–'));
    const columnHead = root.querySelector(`[data-dn-column="${name}"]`);
    const nrvHeading = root.querySelector(`[data-dn-nrv-heading="${name}"]`);
    root.querySelector(`[data-dn-current-basis="${name}"]`).textContent = choice ? choice.label : '';
    columnHead.classList.toggle('dn-nutrition__column-head--two', !hasNrv);
    nrvHeading.hidden = !hasNrv;
    container.replaceChildren(...section.rows.map(item => {
      const row = document.createElement('div');
      row.className = 'dn-nutrition__row';
      row.classList.toggle('dn-nutrition__row--two', !hasNrv);
      if (item.heading) row.classList.add('dn-nutrition__row--heading');
      if (item.group) row.classList.add('dn-nutrition__row--group');
      if (item.label && /^[–-] davon|^davon/i.test(item.label)) row.classList.add('dn-nutrition__row--sub');
      const label = document.createElement('span');
      const amount = document.createElement('span');
      const nrv = document.createElement('span');
      label.textContent = item.heading || item.label;
      if (!item.heading && choice) {
        amount.textContent = item.values[choice.index] || '–';
        nrv.textContent = hasNrv ? item.values[choice.nrvIndex] || '–' : '';
        if (amount.textContent.includes('[BITTE PRÜFEN]') || nrv.textContent.includes('[BITTE PRÜFEN]')) row.classList.add('dn-nutrition__row--review');
      }
      nrv.hidden = !hasNrv;
      row.append(label, amount, nrv);
      return row;
    }));
  }

  function initializeNutrition(root) {
    const parsed = readNutrition(root);
    root.dnParsed = parsed;
    ['nutrition', 'amino'].forEach(name => {
      fillChoices(root, name, parsed.sections[name]);
      fillRows(root, name, parsed.sections[name]);
    });
    root.querySelector('[data-dn-amino-section]').hidden = parsed.sections.amino.rows.length === 0;
    const notes = root.querySelector('[data-dn-notes]');
    notes.replaceChildren(...parsed.notes.map(note => {
      const paragraph = document.createElement('p');
      paragraph.textContent = note;
      return paragraph;
    }));
    notes.hidden = parsed.notes.length === 0;
  }

  function syncVariant(root) {
    const variantId = new URLSearchParams(window.location.search).get('variant') || root.dataset.dnVariant;
    const variant = Array.from(root.querySelectorAll('[data-dn-variant-id]')).find(item => item.dataset.dnVariantId === variantId);
    if (!variant || (root.dataset.dnVariant === variantId && root.dnParsed)) return;
    root.dataset.dnNutrition = variant.dataset.dnFacts || '';
    root.dataset.dnVariant = variantId;
    initializeNutrition(root);
  }

  function syncOpenNutrition() {
    document.querySelectorAll('.dn-nutrition[open]').forEach(syncVariant);
  }

  ['pushState', 'replaceState'].forEach(method => {
    const original = window.history[method];
    window.history[method] = function (...args) {
      const result = original.apply(this, args);
      syncOpenNutrition();
      return result;
    };
  });
  window.addEventListener('popstate', syncOpenNutrition);

  document.addEventListener('click', event => {
    const summary = event.target.closest('.dn-nutrition__trigger');
    if (!summary) return;
    const root = summary.closest('.dn-nutrition');
    if (root) syncVariant(root);
  });
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-dn-basis]');
    if (select) {
      const root = select.closest('.dn-nutrition');
      if (root && root.dnParsed) fillRows(root, select.dataset.dnBasis, root.dnParsed.sections[select.dataset.dnBasis]);
    } else if (event.target.matches('input[type="radio"]')) {
      window.setTimeout(() => {
        const root = document.querySelector('.dn-nutrition[open]');
        if (root) syncVariant(root);
      }, 0);
    }
  });
}

